import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { LayoutTemplate, Loader2, Tag } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { InvoiceSettingsForm } from "@/components/invoices/InvoiceSettingsDialog";
import QuickBooksCard from "@/components/QuickBooksCard";
import EmailTemplatesCard from "@/components/admin/EmailTemplatesCard";

export default function InvoicesTab() {
  const [settings, setSettings] = useState(null);
  useEffect(() => { api.get("/invoice-settings").then((r) => setSettings(r.data)); }, []);
  return (
    <div className="space-y-6 max-w-4xl" data-testid="invoices-tab">
      <div className="flex flex-wrap gap-2">
        <Button variant="outline" asChild><Link to="/invoice-layout" data-testid="admin-invoice-layout-button"><LayoutTemplate size={16} /> Edit invoice layout</Link></Button>
        <Button variant="outline" asChild><Link to="/sticker-designer" data-testid="admin-sticker-designer-button"><Tag size={16} /> Edit sticker designs</Link></Button>
      </div>
      <div className="border rounded-lg bg-card p-5">
        <h2 className="font-display text-xl font-bold mb-1">Business details & invoice defaults</h2>
        <p className="text-sm text-muted-foreground mb-4">Shown on every invoice and statement email.</p>
        {settings ? <InvoiceSettingsForm settings={settings} onSaved={setSettings} /> : <Loader2 className="animate-spin text-primary" />}
      </div>
      <EmailTemplatesCard />
      <QuickBooksCard />
    </div>
  );
}
